export default function createInitPlugin({ actionName = "init" } = {}) {
  return store => {
    for (const action of Object.keys(store._actions)) {
      if (action.endsWith(`/${actionName}`)) {
        store.dispatch(action)
      }
    }
  }
}
